import BaseReportComponent from '@/report/components/BaseReportComponent';
import { computed, ComputedRef, defineComponent } from 'vue';
import { useStore } from 'vuex';
import { CtaBasicReportData } from '../models/CtaBasicReportData';
import CtaSunburstChartVue from '../components/CtaSunburstChart.vue';
import CoverPageVue from '../components/CoverPage.vue';
import HtmlHelper from '@/generic/helpers/HtmlHelper';

export default defineComponent({
    extends: BaseReportComponent,
    components: {
        CtaSunburstChart: CtaSunburstChartVue,
        CoverPage: CoverPageVue,
    },
    setup() {
        const store = useStore();
        const dateCompleted: ComputedRef<string> = computed(() => {
            const date = new Date(reportData.value.dateCompleted);
            return date.toLocaleDateString(undefined, {
                year: 'numeric' as const,
                month: 'numeric' as const,
                day: 'numeric' as const,
            });
        });
        const reportData: ComputedRef<CtaBasicReportData> = computed(() => store.getters['report/report']);
        const domainArray: ComputedRef<Record<string, number>> = computed(() => ({
            actionMove: reportData.value.actionMove,
            actionFollow: reportData.value.actionFollow,
            actionOppose: reportData.value.actionOppose,
            actionBystand: reportData.value.actionBystand,
        }));
        const generalArray: ComputedRef<Record<string, number>> = computed(() => ({
            actionMove: reportData.value.actionMove,
            actionFollow: reportData.value.actionFollow,
            actionOppose: reportData.value.actionOppose,
            actionBystand: reportData.value.actionBystand,
            attentionPower: 1,
            attentionMeaning: 1,
            attentionAffect: 1,
            operatingOpen: 1,
            operatingClosed: 1,
            operatingRandom: 1,
        }));

        return {
            reportData,
            domainArray,
            generalArray,
            dateCompleted,
            sanitizeHtml: HtmlHelper.sanitizeHtml,
        };
    },
});
